module.exports = __webpack_public_path__ + "img/folder-music.aa050cb9.svg";